<template>
  <div class="d-flex justify-center align-center">
    <v-card class="elevation-2" width="300">
      <v-toolbar color="primary" dark>
        <v-toolbar-title class="mx-auto">Emissão de Certificado</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validity" ref="certificate">
          <v-select v-model="eventId" :items="events" :rules="[rules.required]" label="Selecionar evento" prepend-icon="fas fa-calendar-day"></v-select>
          <v-text-field v-model="name" :rules="[rules.required]" label="Nome" name="name" prepend-icon="fas fa-user" autocomplete="name" type="text"></v-text-field>
          <v-text-field v-model="email" :rules="[rules.required]" label="E-mail" name="email" prepend-icon="fas fa-envelope" autocomplete="email" type="text"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="loading" @click="questionShow">Emitir</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="questionDialog" max-width="520" persistent>
      <question @submit="issueCertificate" @close="questionDialog = false"></question>
    </v-dialog>
    
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Question from '../components/Question'

export default {
  data: () => ({
    eventId: null,
    name: null,
    email: null,
    rules: {
      required: v => !!v || 'Requerido.'
    },
    validity: false,
    questionDialog: false
  }),
  computed: {
    loading() {
      return this.$store.state.loading
    },
    events() {
      return this.$store.state.events.map(v => ({ text: v.name, value: v.id }))
    }
  },
  methods: {
    questionShow() {
      this.$store.dispatch('issueCertificate', {
          eventId: this.eventId,
          name: this.name,
          email: this.email
      })
      .then(() => {
        this.$router.push('/imprimir')
      }, () => this.$store.dispatch('getQuestion'))
    }
  },
  watch: {
    name(v) {
      if(v) this.name = v
      .replace(/(^.)/, (m, p) => p.toUpperCase())
      .replace(/\s{2,}/, ' ')
      .replace(/\s(.)/g, (m, p) => ' ' + p.toUpperCase())
    }
  },
  beforeCreate() {
    this.$store.dispatch('getAllEvents')
    this.$store.dispatch('getQuestion')
  },
  components: {
    Question
  }
};
</script>
